import { Collapse, Divider, Grid } from "@mui/material";
import StarCategories from "./starCategories";
import IRatingList from "../../interface/iRatingList";
import React from "react";
import PersonalFeedback from "./personalFeedback";
import FreeText from "./freeText";
import SpeakWithCoachQuestions from "./speakWithCoachQuestions";
import AdditionalQuestions from "./additionalQuestions";
import checkPermissionAdmin from "../../../../functions/checkPermissionAdmin";
import { User, AppContext } from "../../../../context/appContext";

const SearchResultContent = ({
  rating,
}: {
  rating: IRatingList;
}): React.JSX.Element => {
  const {
    user,
  }: {
    user: User;
  } = React.useContext(AppContext);

  return (
    <Collapse in={rating.expand} sx={{ pb: rating.expand ? 2 : 0 }}>
      <Divider sx={{ my: 2 }} />

      <Grid
        container
        sx={{
          mt: 2,
        }}
      >
        <StarCategories rating={rating} />
      </Grid>

      <Divider sx={{ my: 2 }} />

      <Grid item xs={12} sm={4} md={2}>
        <PersonalFeedback personalFeedback={rating.personalFeedback} />
      </Grid>

      {checkPermissionAdmin(user) && (
        <React.Fragment>
          <Divider sx={{ my: 2 }} />

          <Grid item xs={12} sm={4} md={2}>
            <FreeText freeText={rating.freeText} />
          </Grid>

          <Divider sx={{ my: 2 }} />

          <Grid item xs={12} sm={4} md={2}>
            <SpeakWithCoachQuestions
              speakWithCoachQuestions={rating.speakWithCoachQuestions}
            />
          </Grid>

          <Divider sx={{ my: 2 }} />

          <Grid item xs={12} sm={4} md={2}>
            <AdditionalQuestions
              additionalQuestions={rating.additionalQuestions}
            />
          </Grid>
        </React.Fragment>
      )}
    </Collapse>
  );
};

export default SearchResultContent;
